<template>
  <div>

    <Spinner v-if="loading === true" />

    <div
      v-if="loading === false"
      class="row"
    >
      <div class="col-md-6" />
      <div class="col-md-6 create-button">
        <button
          id="deleteMultiple"
          type="button"
          class="btn btn-outline-primary mb-2"
          @click="confirmDeleteText(deletedArry)"
        >
          Delete Selected Elements
        </button>
        <button
          type="button"
          class="btn btn-primary mb-2 ml-1"
          data-toggle="modal"
          data-target="#createModal"
        >
          Create
<!--            {{$store.state.appConfig.layout.queen}}-->
        </button>
        <create
          v-if="$router.currentRoute.name === 'clients'"
          @refresh="getClients()"
        />
      </div>
    </div>
    <basic-table
      v-if="loading === false"
      ref="table"
      :columns="columns"
      :values="rows"
      :actions-obj="actionsArray"
      @dynamicAction="handleActions($event)"
      @choosenObject="getEditedObject($event)"
      @deleteItems="removeItems($event)"
      @deletedMultipleIds="catchIds($event)"
    />
    <edit
      v-if="$router.currentRoute.name === 'clients'"
      :client="editedClient"
      @refresh="getClients()"
    />
    <ResetPassword
      :client="clientId"
      @refresh="renderTable"
    />
  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import BasicTable from '../../../shared/tables/BasicTable.vue'
import Create from './create.vue'
import Edit from './edit.vue'
import ResetPassword from './resetPassword.vue'
import clientService from '../../../services/clientService'
import Spinner from '@/shared/loader/Spinner.vue'

export default {
  components: {
    Spinner,
    BRow,
    BCol,
    Create,
    Edit,
    ResetPassword,
    BasicTable,
  },
  data() {
    return {
      loading: false,
      actionsArray: [],
      editedClient: '',
      clientId: '',
      columns: [

        {
          label: 'Full Name',
          field: 'full_name',
        },
        {
          label: 'Phone',
          field: 'phone_number',
        },
        {
          label: 'Email',
          field: 'email',
        },
        {
          label: 'E-Id',
          field: 'eid_number',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  created() {
    this.getClients()
    this.actionsArray = [{ title: 'Reset Password', icon: 'KeyIcon' }, { title: 'Representatives', icon: 'UsersIcon' }, { title: 'Change Role', icon: 'Edit3Icon' }]
  },
  methods: {
    getClients() {
      this.loading = true
      clientService.index().then(response => {
        this.rows = response.data.data
        this.loading = false
      }).catch(error => {
        this.loading = false
      })
    },
    handleActions(itemObj) {
      switch (itemObj.key) {
        case 'Reset Password': {
          this.clientId = itemObj.id
          $('#resetPasswordModal').modal('show')
        }
          break
        case 'Representatives':
          this.$router.push({ name: 'representatives', params: { id: itemObj.id } })
          break
        case 'Change Role':
          this.changeRole(itemObj.id)
          break
        case 'Projects':
          console.log('Action Object *******>', itemObj)
          break
        default:
          console.log('Action Object *******>', itemObj)
      }
      // this.$router.push({ name: 'representatives', params: { id: itemId } })
    },
    getEditedObject(obj) {
      this.editedClient = obj
    },
    catchIds(ids) {
      this.deletedArry = ids
    },
    removeItems(arr) {
      this.loading = true
      this.confirmDeleteText(arr)
    },
    confirmDeleteText(arr) {
      if (arr.length > 0) {
        this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            clientService.delete(arr.join()).then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Deleted!',
                  text: 'Your Items have been deleted.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(() => {
                  this.renderTable()
                })
              }
            }).catch(error => {
              this.loading = false
              return Promise.reject(error)
            })
          } else if (result.dismiss === 'cancel') {
            this.$swal({
              title: 'Cancelled',
              text: '',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.loading = false
          } else {
            this.loading = false
          }
        })
      }
    },
    confirmChangeRoleText(id) {
      if (id !== null && id !== undefined) {
        this.$swal({
          title: 'Are you sure of changing this client to representative role?',
          text: '',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, change it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            clientService.changeRole(id).then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Role Changed!',
                  text: 'Role Has Changed Successfully.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(() => {
                  this.loading = false

                  this.renderTable()
                })
              }
            }).catch(error => {
              this.loading = false
              this.renderTable()
              return Promise.reject(error)
            }).catch(error => {
              this.loading = false
            })
            this.loading = false
          } else if (result.dismiss === 'cancel') {
            this.$swal({
              title: 'Cancelled',
              text: '',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.loading = false
          } else {
            this.loading = false
          }
        })
      }
    },
    changeRole(id) {
      this.loading = true
      this.confirmChangeRoleText(id)

    },
    renderTable() {
      this.getClients()
    },

  },
}
</script>
<style>
input[type="checkbox"]:checked + label::after {
  content: '';
  position: absolute;
  width: 1.2ex;
  height: 0.4ex;
  background: rgba(0, 0, 0, 0)!important;
  top: 0.9ex;
  left: 0.4ex;
  border: 3px solid blue;
  border-top: none;
  border-right: none;
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

input[type="checkbox"] {
  line-height: 2.1ex;
}


</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';

</style>
